import { ELinkVariant, Link } from '@outdoorsyco/bonfire';
import React from 'react';

import { DISCLAIMER_LINKS } from '@/constants/checkout';

type TPrivacyLinkProps = {
  variant?: ELinkVariant;
  children: React.ReactNode;
};

const PrivacyLink: React.FC<TPrivacyLinkProps> = ({
  variant = ELinkVariant.Underline,
  children,
}) => (
  <Link href={DISCLAIMER_LINKS.PRIVACY} variant={variant} target="_blank">
    {children}
  </Link>
);

export default PrivacyLink;
